import React from 'react';

// Scroll utility functions
export const scrollToTop = (behavior: ScrollBehavior = 'smooth') => {
  window.scrollTo({ top: 0, behavior });
};

export const scrollToElement = (element: HTMLElement | null, behavior: ScrollBehavior = 'smooth') => {
  if (element) {
    element.scrollIntoView({ 
      behavior, 
      block: 'start',
      inline: 'nearest'
    });
  }
};

// Custom hook for scroll to top on mount
export const useScrollToTop = (dependencies: React.DependencyList = []) => {
  React.useEffect(() => {
    scrollToTop();
    // Caller passes deps; hook API cannot use a literal array here
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
}; 